import { Component } from '@theme/component';

class CareSuggestion extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.bind();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    if (this.refs.dialog?.open) this.refs.dialog.close();
  }

  bind() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { disclosure, trigger, panel, dialog, closeButton } = this.refs;
    if (!disclosure || !trigger || !panel || !dialog || !closeButton || typeof dialog.showModal !== 'function') return;
    disclosure.open = false;
    dialog.append(panel);
    trigger.setAttribute('aria-haspopup', 'dialog');
    const options = { signal: this.controller.signal };
    const open = () => {
      if (!dialog.open) dialog.showModal();
      (panel.querySelector('[data-care-result]') || panel.querySelector('textarea') || closeButton).focus();
    };
    trigger.addEventListener('click', event => { event.preventDefault(); open(); }, options);
    closeButton.addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus(); }, options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }, options);
    if (panel.querySelector('[data-care-result]')) open();
  }
}

if (!customElements.get('sf-care-suggestion-component')) customElements.define('sf-care-suggestion-component', CareSuggestion);
